<template>
  <div class="events">
    <main-content
      right-sidebar="true"
    >
      <asset-gallery
        :autoplay="true" 
        :assets="activePage.gallery" 
        :show-nav="true"
      />
    </main-content>
    <right-sidebar
      v-if="false"
      :logo="$store.state.config.sidebarLogo"
      :heading="activePage.label"
      :description="activePage.description"
      :navigation-items="sidebarNavigationItems"
    > 
    </right-sidebar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MainContent from './MainContent'
import RightSidebar from './RightSidebar'
import VideoPlayer from '@/components/VideoPlayer'
import AssetGallery from '@/components/AssetGallery'

export default {
  components: { MainContent, RightSidebar, VideoPlayer, AssetGallery },

  computed: {
    ...mapGetters([
      'activePage',
      'activeSubNavigation'
    ]),

    key () {
      return this.activePage._id
    },

    sidebarContentKey () {
      return this.activePage.label + this.activePage.description
    },

    sidebarNavigationItems () {
      let sidebarNavigationItems = []
      this.activeSubNavigation.forEach(_item => {
        let item = {
          to: `/category/${this.$store.state.route.params.categoryId}/page/${_item.pageId}`,
          label: _item.label,
          icon: _item.icon
        }
        sidebarNavigationItems.push(item)
      })
      return sidebarNavigationItems
    },    

    sidebarNavigationKey () {
      return JSON.stringify(this.activeSubNavigation)
    },

    language () {
      return this.$store.getters.language
    } 
  },

  methods: {
    convertToThumbnail (path) {
      const paths = path.split('/')
      if (path.substring(path.lastIndexOf('.') + 1, path.length) == 'mp4') {
        return paths[0] + '/thumb_' + paths[1] + '.jpg'
      } else {
        return paths[0] + '/thumb_' + paths[1]
      }
    },

    getSlideFileType (url) {
      const filetype = url.substring(url.lastIndexOf('.') + 1, url.length)

      if (['mp4', 'mov'].indexOf(filetype) !== -1) {
        return 'video'
      } else {
        return 'image'
      }
    },

    handleSliderDrag () {
      this.isSliderDragging = true
      if (this.dragTimeout === null) {
        this.dragTimeout = setTimeout(() => {
          this.dragTimeout = null
          this.isSliderDragging = false
        }, 1000) 
      }
    },

    handleSliderDragEnd () {
      this.dragTimeout = null
      this.isSliderDragging = false
    },
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";

.events {

  .background--show {
    opacity: 1;
    transition: opacity 1s;
  }

  .background--hide {
    opacity: 0;
    transition: opacity 1s;
  }

  &__background {
    height: 100%;
    width: 100%;
    position: relative;

    &-heading {
      font-size: 10rem;
      font-weight: 600;
      color: $white;
      position: absolute;
      top: 5rem;
      left: 5rem;
      letter-spacing: 0.05em;
      line-height: 1;
      padding-top: 2rem;
      text-shadow: 0px 0px 5px rgba($black, 0.5);

      &:before {
        content: '';
        width: 20rem;
        height: 1.5rem;
        background-color: $lblue;
        position: absolute;
        top: 0;
        left: 0.7rem;
      }
    }

    & .video {
      height: 77rem;
      object-fit: contain;
      width: 152rem;
    }

    img {
      width: 100%;
      object-fit: cover;
    }
  }

  &__event-slider-controls {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    font-size: 4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 3.75rem 0 6.25rem;

    div {
      transition: opacity 0.3s;

      &[aria-disabled=true] {
        opacity: 0.2;
      }
    }
  }  

  &__event-slider {
    background: rgba($lblue, 1);
    bottom: 0;
    position: absolute;
    width: 152rem;
    height: 23.25rem;
    padding: 2.35rem 8rem 2.4rem 9.8rem;

    .tns-item {
      opacity: 0;
      transition: opacity .3s .3s;

      &.tns-slide-active {
        opacity: 1;
        transition: opacity .3s;
      }
    }

    .slide {
      display: flex;
      padding: 0 2rem;

      &--reverse {
        flex-direction: row-reverse;

        .slide__content {
          padding: 0 1rem 0 0;
        }
      }

      &__image-wrapper, &__content {
        position: relative;
        width: 50%;
      }

      &__image-reference {
        background-color: #000;
        border-radius: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.5em;
        font-size: 1.5rem;
        position: absolute;
        top: 0;
        left: 0;
        height: 3rem;
        width: 3rem;
      }

      &__video-circle-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          height: 10rem;
          width: 10rem;
          transition: transform 0.3s;
        }

        &--active {
          svg {
            transform: scale(1.1) rotate(-90deg);
          }
        }
      }

      &__content {
        padding-left: 1rem;
      }

      &__image {
        height: 18.5rem;
        object-fit: cover;
        width: 20rem;
      }

      &__heading {
        font-size: 1.5rem;
        font-weight: 400;
        margin-bottom: 0.5em;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }

      &__description {
        font-size: 1.5rem;
        font-weight: 200;
        line-height: 1.2;
        letter-spacing: 0.05em;
      }
    }
  }

  .sidebar__nav-item {
    transition: padding-left 0.3s;
    &.router-link-active, &--active {
      // border-top: 1px solid $lblue;
      // padding-left: 1em;
      color: $bottombar-text-color-active;
    }
  }
}
</style>